<template>
  <div class="page-wrapper">
    <article id="post-1905" class="full post-1905 page type-page status-publish hentry">
      <div class="page-content clearfix the-content-parent">
        <div data-elementor-type="wp-page" data-elementor-id="1905" class="elementor elementor-1905" data-elementor-post-type="page">
          <Splide ref="splideRef" :options="slideOptions">
            <SplideSlide>
              <img :src="homeContentStore.contents.previewBanner.image"/>
              <section class="elementor-section elementor-top-section elementor-element elementor-element-5174a02 elementor-section-height-min-height elementor-section-items-stretch elementor-section-content-bottom elementor-section-boxed elementor-section-height-default" data-id="5174a02" data-element_type="section" data-e-type="section" data-settings="{'background_background':'classic'}">
                <div  class="elementor-container elementor-column-gap-no">
                  <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-4596ae5" data-id="4596ae5" data-element_type="column" data-e-type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-7f3a7ab elementor-headline--style-rotate elementor-widget elementor-widget-animated-headline" data-id="7f3a7ab" data-element_type="widget" data-e-type="widget" data-settings="{'headline_style':'rotate','animation_type':'wave','rotating_text':'Innovate.\nSucceed.','loop':'yes','rotate_iteration_delay':2500}" data-widget_type="animated-headline.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-headline elementor-headline-animation-type-wave elementor-headline-letters">
                              <div class="elementor-headline-plain-text elementor-headline-text-wrapper">{{ homeContentStore.contents.previewBanner.title }}<br></div>
                              <p class="elementor-headline-plain-text elementor-headline-text-wrapper elementor-headline-text-desc ">{{ homeContentStore.contents.previewBanner.descriptions }}<br></p>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                  <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-25bb8b4 elementor-hidden-mobile" data-id="25bb8b4" data-element_type="column" data-e-type="column">
                    <div class="elementor-widget-wrap"></div>
                  </div>
                </div>
              </section>
            </SplideSlide>
          </Splide>
        </div>
      </div>
    </article>
  </div>
  <section class="elementor-section elementor-top-section elementor-element elementor-element-8339169 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="8339169" data-element_type="section" data-e-type="section" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;}">
    <div  class="elementor-container- elementor-container-slogan elementor-column-gap-no">
      <!-- <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1397ddc elementor-hidden-mobile" data-id="1397ddc" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap"></div>
      </div> -->
      <div class="elementor-column slogan elementor-col-50 elementor-top-column elementor-element elementor-element-2fb40d7" data-id="2fb40d7" data-element_type="column" data-e-type="column" data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-5b191cc elementor-widget__width-auto elementor-widget elementor-widget-heading" data-id="5b191cc" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
            <div class="elementor-widget-container">
              <h3 class="elementor-heading-title elementor-size-default slogan">{{ settings.slogan }}</h3>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-6c28eaf vamtam-has-underline-anim elementor-widget elementor-widget-button" data-id="6c28eaf" data-element_type="widget" data-e-type="widget" data-widget_type="button.default">
            <div class="elementor-widget-container">
              <div class="elementor-button-wrapper">
                <a class="elementor-button elementor-button-link elementor-size-sm" :href="settings.url_btn_slogan">
                  <span class="elementor-button-content-wrapper">
                    <span class="elementor-button-text">{{ settings.title_button_slogan }}</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div class="elementor-element elementor-element-4b4b287 elementor-widget__width-auto elementor-absolute elementor-widget-divider--view-line elementor-widget elementor-widget-divider" data-id="4b4b287" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;}" data-widget_type="divider.default">
            <div class="elementor-widget-container">
              <div class="elementor-divider">
                <span class="elementor-divider-separator"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<!-- <script>
  import "@/assets/css/home.css";
  import { onMounted } from "vue";
  import PreviewBannerSection from './Home/PreviewBannerSection.vue';

  export default {
    name: 'PreviewBannerView',
    components: {
      PreviewBannerSection,
    },
    watch: {
      $route(to) {
        document.title = to.meta.title || "Default Title";
      },
    },
    mounted() {
      document.title = this.$route.meta.title || "Default Title";
    },
    setup() {
      onMounted(() => {
        
      });

      return {
        modules: [],
      };
    },
  }
</script> -->
<script>
  import "@/assets/css/home.css";
  import { Splide, SplideSlide } from '@splidejs/vue-splide';
  import '@splidejs/vue-splide/css';
  import { ref, onMounted, watch } from 'vue'
  import { useHomeContentStore } from '@/stores/homeContentStore'

  export default {
    name: 'PreviewBannerView',
    props: {
      slug: String
    },
    setup(props) {
      const splideRef = ref(null);
      const homeContentStore = useHomeContentStore()
      const slideOptions = {
        type: 'slide',
        autoplay: true,
        interval: 3000,
        pagination: false,
        arrows: false,
        cover: true,
        heightRatio : 0.5,
        pauseOnHover: false,
        pauseOnFocus: false,
        rewind: true,
      };

      
      const settings = {
        "slogan": "Commited to Better Life",
        "title_button_slogan": "Contact us",
        "url_btn_slogan": "/contact"
      };
      const onSplideMounted = (splide) => {
        splide.Components.Autoplay.play();
      };

      onMounted(async () => {
        await homeContentStore.fetchPreviewPage(props.slug)
        splideRef.value?.splide?.Components?.Autoplay?.play();
      })
      

      watch(() => props.slug,
        async (newSlug) => {
          await homeContentStore.fetchPreviewPage(newSlug)
        }
      )

      return {
        splideRef,
        onSplideMounted,
        slideOptions: slideOptions,
        homeContentStore,
        settings: settings,
      }
    },
    data() {
      return{
      }
    },
    components: {
      Splide, 
      SplideSlide,
    },
  }
</script>
<style>
  .elementor-kit-5 {
    --e-global-typography-03f1db1-font-size: 40px;
    --e-global-typography-03f1db1-line-height: 60px;
  }
</style>
<style scoped>
  .elementor-1905 .elementor-element.elementor-element-5174a02:not(.elementor-motion-effects-element-type-background), .elementor-1905 .elementor-element.elementor-element-5174a02 > .elementor-motion-effects-container > .elementor-motion-effects-layer {
    background-image: none;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .elementor-1905 .elementor-element.elementor-element-7f3a7ab .elementor-headline {
    line-height: 30px;
  }
  .elementor-1905 .elementor-element.elementor-element-7f3a7ab .elementor-headline-plain-text {
    font-size: 20px;
    /* background-color: #fff;
    color: #006940; */
    background-color: rgba(0,0,0,0.5);
    color: #fff;
    padding: 0px 5px;
    line-height: 30px;
  }
  .elementor-1905 .elementor-element.elementor-element-7f3a7ab .elementor-headline-plain-text.elementor-headline-text-desc {
    font-size: 14px;
    font-weight: 500;
    /* background-color: #fff;
    color: #006940; */
    background-color: rgba(0,0,0,0.5);
    color: #fff;
    padding: 5px;
    line-height: 16px;
  }
  .elementor-1905 .elementor-element.elementor-element-6c28eaf .elementor-button:hover, .elementor-1905 .elementor-element.elementor-element-6c28eaf .elementor-button:focus {
    color: #006940;
  }
  .elementor-1905 .elementor-element.elementor-element-5174a02 > .elementor-container > .elementor-column > .elementor-widget-wrap {
    align-content: flex-start !important;
    align-items: flex-start !important;
    margin-top: 80px;
    padding-block-end: 20px;
  }
</style>